import { render, staticRenderFns } from "./ModalEstabelecimento.vue?vue&type=template&id=5dcdc414&lang=true&"
import script from "./ModalEstabelecimento.vue?vue&type=script&lang=js&"
export * from "./ModalEstabelecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports